// import Login from "@/components/Login/Login";
// import Dashboard from "@/components/dashboard/Dashboard";


const Login = () => import('@/components/Login/Login')
const Dashboard = () => import('@/components/dashboard/Dashboard')
const UberTripView = () => import('@/components/Trips/uberTrips/UberTripView')


export const routes = [
    {
        path:'/login',
        component: Login,
        meta: {
            auth:false,
        }
    },
    {
        path:'/dashboard',
        component: Dashboard,
        meta: {
            auth: true
        }
    },
    {
        // Shareable ride link, keyed on the Uber trip UUID. Open to anyone
        // holding the URL - it is sent to the crew, who have no login here.
        path:'/uber/trip-view/:uberTripId',
        component: UberTripView,
        meta: {
            auth: false
        }
    },
]